export default  {"src":"/_next/static/image/public/assets/icons/bank-of-ireland-logo.834c59dd90ce17260fce2d1c353e7902.svg","height":142,"width":181};